export default function() {

  return {
    placeholder: 'hh:mm a',

    viewHours(modelHours) {
      const viewValue = {};
      if (modelHours === 0) {
        viewValue.hours = 12;
        viewValue.meridian = 'AM';
      } else if (modelHours <= 12) {
        viewValue.hours = modelHours;
        viewValue.meridian = modelHours === 12 ? 'PM' : 'AM';
      } else if (modelHours <= 23) {
        viewValue.hours = modelHours - 12;
        viewValue.meridian = 'PM';
      } else {
        throw new Error('Hours: Hours must be between 0 and 23');
      }
      return viewValue;
    },

    modelHours(hours, meridian) {
      const hoursInt = parseInt(hours, 10);

      if (meridian === 'AM') {
        return hoursInt === 12 ? 0 : hoursInt;
      } else if (hoursInt > 0 && hoursInt < 12) {
        return hoursInt + 12;
      } else {
        return hoursInt;
      }
    },

    filterIncremented(hours, meridian) {
      if (hours > 12) {
        return [1, meridian];
      } else if (hours === 12) {
        return [hours, meridian === 'AM' ? 'PM' : 'AM'];
      }
      return [hours, meridian];
    },

    filterDecremented(hours, meridian) {
      if (hours === 0) {
        return [12, meridian];
      } else if (hours === 11) {
        return [hours, meridian === 'AM' ? 'PM' : 'AM'];
      }
      return [hours, meridian];
    },

    getTimeDisplay(time) {
      if (time) {
        return `${time.hours}:${time.minutes} ${time.meridian}`;
      }
    },

    adjustNegativeDecrement(hours, belowStep) {
      return belowStep ? hours += 12 : hours;
    }
  };
}

